/**
 * useScreenshotDetection — iOS only.
 *
 * Listens for the custom event 'ios-screenshot-detected' posted from native
 * AppDelegate.swift when iOS detects a screenshot. When a conversation_id
 * is active, we ping the backend to insert a system message in the chat.
 */
import { useEffect } from 'react';
import { Capacitor } from '@capacitor/core';
import axios from 'axios';

export const useScreenshotDetection = (conversationId) => {
  useEffect(() => {
    if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'ios') return;
    if (!conversationId) return;

    const handler = async () => {
      try {
        await axios.post('/api/privacy/screenshot', { conversation_id: conversationId });
      } catch (e) {
        // silent — we don't want UI errors from this
      }
    };

    window.addEventListener('ios-screenshot-detected', handler);
    return () => window.removeEventListener('ios-screenshot-detected', handler);
  }, [conversationId]);
};
